export default __webpack_public_path__ + "static/media/add.bdfab5aa.svg";